module.exports = __webpack_public_path__ + "static/media/appsflyer.ce060988.png";